<template>
	<v-list-item :to="path">
		<template v-if="icon" v-slot:prepend>
			<img v-if="isSvgIcon" :src="icon" width="24" height="24" />
			<v-icon v-else color="primary">{{ icon }}</v-icon>
		</template>
		<v-list-item-title>{{ text }}</v-list-item-title>
	</v-list-item>
</template>

<script>
export default {
	name: 'NavigationItem',
	props: {
		path: {
			type: String,
			require: true,
		},
		text: {
			type: String,
			require: true,
		},
		icon: {
			type: String,
		},
	},
	data: () => ({}),
	computed: {
		currentPath() {
			return this.$route.path ?? '';
		},
		isSvgIcon() {
			return this.icon?.startsWith('data:image/svg+xml');
		},
	},
};
</script>
<style scoped></style>
